import { DownloadFolderItem } from '@/service/interface';
import JSZip from 'jszip';
import { chunk } from 'lodash-es';

const MAX_CONCURRENT_DOWNLOADS = 50;

export async function downloadAndZipFiles(files: DownloadFolderItem[], filename = 'music-pack'): Promise<void> {
  try {
    const batches = chunk(files, MAX_CONCURRENT_DOWNLOADS);

    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      const batch = batches[batchIndex];
      const zip = new JSZip();
      const usedNames = new Set<string>();

      await Promise.allSettled(
        batch.map(async (file, index) => {
          try {
            const response = await fetch(file.source_url);
            if (!response.ok) throw new Error(`Failed to fetch ${file.name}`);

            const blob = await response.blob();
            const extension = 'wav';
            const safeName = file.name.replace(/[/\\?%*:|"<>]/g, '_') || `track-${batchIndex * MAX_CONCURRENT_DOWNLOADS + index + 1}`;

            // Handle duplicate names
            let uniqueName = safeName;
            let counter = 1;
            while (usedNames.has(`${uniqueName}.${extension}`)) {
              uniqueName = `${safeName}-(${counter})`;
              counter++;
            }

            usedNames.add(`${uniqueName}.${extension}`);
            zip.file(`${uniqueName}.${extension}`, blob);
          } catch (err: any) {
            console.warn(`Skipping file ${file.name}: ${err.message}`);
            // Ignore this file and continue with others
          }
        }),
      );

      if (Object.keys(zip.files).length > 0) {
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(zipBlob);
        link.download = batches.length > 1 ? `${filename}-[${batchIndex + 1}/${batches.length}].zip` : `${filename}.zip`;
        link.click();

        // Clean up the URL object
        setTimeout(() => URL.revokeObjectURL(link.href), 100);
      }
    }
  } catch (error) {
    console.error('Failed to download and zip files:', error);
    throw error;
  }
}
